import { CreateUpdateMooringComponent, MooringComponent } from './MooringComponent';

class BaseMooringBuoy {
  MoorlogNo!: string;
  AnalysisNo!: string;
  DimForce?: number;
  IsAccident!: boolean;
  Size!: number;
  Row!: number;
  Column!: number;
  PullDownKg!: number;
  PullDownMeter!: number;
  ResidualPullDownMeter!: number;
  ResidualDriftKg!: number;
  IsLightBuoy!: boolean;
  MblRopes!: number | null;
  MblSinkRopes!: number | null;
  MblMainStrap!: number | null;
  MblStraps!: number | null;
  MblAdditionalSafety!: number | null;
  SortIndex!: number;
}

export class UpdateMooringBuoyDto extends BaseMooringBuoy {
  Id!: number;
  Components!: CreateUpdateMooringComponent[];
}
export class AddMooringBuoyDto {
  MoorlogNo!: string;
  AnalysisNo!: string;
  StartGridLineId!: number;
  EndGridLineId!: number;
}

export class MooringBuoy extends BaseMooringBuoy {
  Id!: number;
  Components!: MooringComponent[];
  HasUnresolvedComments!: boolean;
  HasUnresolvedComponentComments!: boolean;
  HasComments!: boolean;
}

export class MooringProductionBuoyDto {
  Id!: number;
  MooringId!: number;

  MoorlogNo!: string;
  AnalysisNo!: string;
  PullDownKg!: number;
  Buoy!: string;
  BuoySize!: number;
  MblRopes!: number | null;
  MblStraps!: number | null;
  FlexilinkMainStrap!: string;
  FlexilinkBuoyStrap!: string;
  FlexilinkStrapExtension!: string;
  MinMblFlexilinkAdditionalSafety!: number | null;
  FlexilinkAdditionalSafety!: string;
  ShackleForBuoy!: string;
  IsLightBuoy!: boolean;

  BuoySlot!: MooringProductionBuoySlotDto | null;
  MainStrapSlot!: MooringProductionBuoySlotDto | null;
  BuoyStrapSlot!: MooringProductionBuoySlotDto | null;
  AdditionalSafetySlot!: MooringProductionBuoySlotDto | null;
  ShackleSlot!: MooringProductionBuoySlotDto | null;
}

export class MooringProductionBuoySlotDto {
  ComponentId?: number;
  ArticleProductId?: number;
  ProductName?: string;
}

export class MooringProductionBuoyEditDto {
  BuoyId!: number;
  AnalysisNo!: string;
  PullDownKg!: number | null;
  IsLightBuoy?: boolean;
  BuoySlot?: MooringProductionBuoySlotDto;
  MainStrapSlot?: MooringProductionBuoySlotDto;
  BuoyStrapSlot?: MooringProductionBuoySlotDto;
  AdditionalSafetySlot?: MooringProductionBuoySlotDto;
  ShackleSlot?: MooringProductionBuoySlotDto;
}
